import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function FlyToMarker({ position, zoom = 13 }) {
  const map = useMap();

  useEffect(() => {
    if (position) {
      map.flyTo(position, zoom);
    }
  }, [position]);

  return null;
}
